import * as React from 'react';
import { connect } from 'react-redux';
import { ReflowableContentSettingState } from '../../reducers/ui/reflowableContentSetting';
import { Dispatch, Action } from 'redux';
import { AppStates } from '../../reducers/app';
import {
    SettingTabPanelList,
    SettingTabPanelListRow,
    SettingTabPanelListRowImageTitle,
  } from '../common/SettingTabPanelList';
import ToolIconRadioButtonSet from '../common/ToolIconRadioButtonSet';
import { FontType } from '../../drawing/types';
import ReflowableContentUIAction from '../../actions/ui/ReflowableContentUIAction';
import ReflowableContentSettingLineHeightSlider from './ReflowableContentSettingLineHeightSlider';
import ReflowableContentSettingFontSizeSlider from './ReflowableContentSettingFontSizeSlider';
import ReflowableContentSettingPaddingSlider from './ReflowableContentSettingPaddingSlider';
import SelectableRectangleIconButton
from '../common/SelectableIconButton/SelectableRectangleIconButton';

interface ReflowableContentSettingPanelProps extends ReflowableContentSettingState {
  readonly dispatch: Dispatch<Action>;
}

const largeButtonContainerStyle: React.CSSProperties = {
  width: '86px',
  height: '52px',
  marginLeft: '10px',
  marginRight: '10px',
  marginBottom: '3px',
};

const rowStyle: React.CSSProperties = {
  paddingTop: '14px',
  paddingBottom: '14px',
};

const borderStyle: React.CSSProperties = {
  width: '100%',
  height: 2,
  backgroundColor: '#bebebe',
  marginTop: 0,
  marginBottom: 0,
  borderStyle: 'none',
};

const ReflowableContentSettingPanel: React.SFC<ReflowableContentSettingPanelProps> =
React.memo((props) => {
  const { dispatch, fontType, fontSize, lineHeight, padding } = props;

  return (
    <SettingTabPanelList style={{ width: '514px', margin: '4px 60px 18px 62px' }}>
      <SettingTabPanelListRow style={rowStyle}>
        <SettingTabPanelListRowImageTitle imgName="text_txtbox_typeface" />
        <ToolIconRadioButtonSet
          style={{ justifyContent: 'center', width: '100%',
            marginTop: '2px', marginBottom: '2px' }}>
          <SelectableRectangleIconButton
            title="そのまま"
            containerStyle={largeButtonContainerStyle}
            imagePath="images/setting-popup/typeface/btn_typeface_default"
            active={fontType === FontType.ContentAware}
            onClick={() => {
              ReflowableContentUIAction.setFontType(FontType.ContentAware, dispatch);
            }} />
          <SelectableRectangleIconButton
            title="明朝体"
            containerStyle={largeButtonContainerStyle}
            imagePath="images/setting-popup/typeface/btn_typeface_mincho"
            active={fontType === FontType.Mincho}
            onClick={() => {
              ReflowableContentUIAction.setFontType(FontType.Mincho, dispatch);
            }} />
          <SelectableRectangleIconButton
            title="ゴシック体"
            containerStyle={largeButtonContainerStyle}
            imagePath="images/setting-popup/typeface/btn_typeface_gothic"
            active={fontType === FontType.Gothic}
            onClick={() => {
              ReflowableContentUIAction.setFontType(FontType.Gothic, dispatch);
            }} />
        </ToolIconRadioButtonSet>
      </SettingTabPanelListRow>
      <hr style={borderStyle} />

      <SettingTabPanelListRow style={rowStyle}>
        <SettingTabPanelListRowImageTitle imgName="text_txtbox_font_size" />
        <ReflowableContentSettingFontSizeSlider fontSize={fontSize} dispatch={dispatch} />
      </SettingTabPanelListRow>

      <hr style={borderStyle} />

      <SettingTabPanelListRow style={rowStyle}>
        <SettingTabPanelListRowImageTitle imgName="text_between_lines" />
        <ReflowableContentSettingLineHeightSlider lineHeight={lineHeight} dispatch={dispatch} />
      </SettingTabPanelListRow>

      <hr style={borderStyle} />

      <SettingTabPanelListRow style={rowStyle}>
        <SettingTabPanelListRowImageTitle imgName="text_margin" />
        <ReflowableContentSettingPaddingSlider padding={padding} dispatch={dispatch} />
      </SettingTabPanelListRow>
    </SettingTabPanelList >
  );
});

const mapStateToProps = (appStates: AppStates) => ({ ...appStates.ui.reflowableContentSetting });

export default connect(mapStateToProps)(ReflowableContentSettingPanel);
